<template>
  <div>

    <v-dialog
          v-model="activatePassEnterBox"
          max-width="420"
          content-class="dialog-login-signup transitionblur"
        >
            <v-card class="password-dialog">
                <v-card-title class="metamask-header">
                  <LogoWhite></LogoWhite>
                </v-card-title>
                  
                  <v-card-text class="metamask-content">
                      <div v-if="!this.sendToWalletOption" class="info-section mb-4">
                        <v-icon size="20" color="white" class="mr-2">mdi-shield-key</v-icon>
                        <p class="info-text">
                            Transfer can take up to 3 days. We are checking each transfer and validating it for security reasons. We will charge fee transfer cost in MUZ tokens, according to current network transfer rate.
                        </p>
                      </div>
                    <v-form ref="formpasswallet" v-model="validpass" id="form-pass-wallet">     
                      <v-text-field
                          autocomplete="current-password"
                          class="dialog-password-field"
                          v-model.lazy="pass"
                          label="Enter Password"
                          :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="() => (value = !value)"
                          :type="value ? 'password' : 'text'"
                          :rules="passwordRules"
                          @input="pass = $event.target.value"
                          required
                          color="white"
                          @focus="checkErrorsPass()"
                          :error-messages="passwordErrors"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>


                  <v-card-actions class="metamask-actions">                      
                    <v-btn
                          v-if="!this.sendToWalletOption"
                          form="form-pass-wallet"
                          :disabled="!validpass"
                          variant="outlined"
                          color="white"
                          class="dialog-action-btn"  
                          @click="sendTokensPass()"
                          @keyup.enter.native="sendTokensPass()"
                      >
                        <span>Send</span>
                      </v-btn>
                      <v-btn
                          v-if="this.sendToWalletOption"
                          form="form-pass-wallet"
                          :disabled="!validpass"
                          variant="outlined"
                          color="white"
                          class="dialog-action-btn"
                          @click="sendTokensPassWallet()"
                          @keyup.enter.native="sendTokensPassWallet()"
                      >
                        <span>Send</span>
                      </v-btn>
                  </v-card-actions>
          </v-card>   
    </v-dialog>


    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
            <div class="fonts-white container pl-0 pr-1">
              <div class="overlay-grey-web">
                
                <!-- Wallet Header -->
                <div class="wallet-header">
                  <div class="header-content">
                    <v-icon class="header-icon">mdi-wallet</v-icon>
                    <h1 class="header-title">Wallet</h1>
                  </div>
                </div>

                <v-divider class="my-4" style="opacity:0.3;"></v-divider>

                <v-row justify="center" class="pa-0 ma-0 pt-4">
                  <v-col cols="12" class="pa-0 ma-0">
                    <div v-if="this.cryptoDashboardData" class="pa-0 ma-0">                     

                              <div v-if="this.isLogged && this.cryptoUserData" class="pa-0 ma-0">
                                  
                                  <!-- Balance Cards Grid -->
                                  <div class="balance-cards-grid">
                                    
                                    <!-- Total Tokens Card -->
                                    <div class="balance-card balance-card-primary">
                                      <div class="balance-card-header">
                                        <v-icon size="32" class="balance-icon">mdi-coins</v-icon>
                                        <span class="balance-label">Total Balance</span>
                                      </div>
                                      <div class="balance-value">{{ formatNumber(this.cryptoUserData.tokens) }} <span class="currency">MUZ</span></div>
                                    </div>

                                    <!-- Staked Card -->
                                    <div class="balance-card balance-card-staked">
                                      <div class="balance-card-header">
                                        <v-icon size="32" class="balance-icon">mdi-lock</v-icon>
                                        <span class="balance-label">Staked</span>
                                      </div>
                                      <div class="balance-value-small">{{ getStaked }}</div>
                                    </div>

                                    <!-- Current Dividend Card -->
                                    <div class="balance-card balance-card-dividend">
                                      <div class="balance-card-header">
                                        <v-icon size="32" class="balance-icon">mdi-chart-line</v-icon>
                                        <span class="balance-label">Current Dividend</span>
                                      </div>
                                      <div class="balance-value-small">
                                        {{ formatNumber(this.cryptoUserData.dividend_current) }} MUZ
                                        <span class="percentage">{{ formatNumber(this.cryptoUserData.dividend_current_per) }}%</span>
                                      </div>
                                    </div>

                                    <!-- Potential Dividend Card -->
                                    <div class="balance-card balance-card-potential">
                                      <div class="balance-card-header">
                                        <v-icon size="32" class="balance-icon">mdi-trending-up</v-icon>
                                        <span class="balance-label">Potential Dividend</span>
                                      </div>
                                      <div class="balance-value-small">
                                        {{ formatNumber(this.cryptoUserData.dividend_potential) }} MUZ
                                        <span class="percentage">{{ formatNumber(this.cryptoUserData.dividend_potential_per) }}%</span>
                                      </div>
                                    </div>

                                  </div>

                                  <v-divider class="section-divider"></v-divider>

                                  <!-- Staking Section -->
                                  <div class="wallet-section">
                                    <h2 class="section-title">
                                      <v-icon left>mdi-lock-outline</v-icon>
                                      Staking
                                    </h2>

                                    <!-- Stake In Form -->
                                    <v-form ref="stakingformin" v-model="validStakeIn" id="staking-form-in" class="staking-form">
                                      <div class="form-card">
                                        <div class="form-header">
                                          <v-icon color="success">mdi-lock-plus</v-icon>
                                          <span class="form-title">Stake Tokens</span>
                                        </div>
                                        <div class="form-content">
                                          <v-text-field                                                    
                                            v-model="tokens_stake_in"
                                            class="wallet-input"
                                            :rules="tokensRulesStakeIn"
                                            label="Number of Tokens"
                                            required
                                            color="white"
                                            @focus="checkErrorsTokensStakeIn()"
                                            :error-messages="tokenValidationErrorsStakeIn"
                                          ></v-text-field>
                                          <v-btn
                                            @click="stakeTokensIn();"
                                            @keyup.enter.native="stakeTokensIn();"
                                            form="staking-form-in"
                                            :disabled="!validStakeIn"
                                            variant="outlined"
                                            color="success"
                                            class="form-action-btn"
                                          >
                                            <v-icon left size="18">mdi-lock-plus</v-icon>
                                            <span>Stake Tokens</span>
                                          </v-btn>
                                        </div>
                                      </div>
                                    </v-form>

                                    <v-row v-if="this.stakeTokensError" justify="center" class="pa-0 pt-4 pb-0 ma-0">
                                      <v-col cols="12" align="center" class="pa-0 ma-0">
                                        <v-alert type="error" density="compact" class="error-alert">
                                          Something went wrong... Not enough tokens or other error occurred. Please try again later.
                                        </v-alert>
                                      </v-col>  
                                    </v-row>

                                    <!-- Unstake Form -->
                                    <v-form ref="stakingformout" v-model="validStakeOut" id="staking-form-out" class="staking-form">
                                      <div class="form-card">
                                        <div class="form-header">
                                          <v-icon color="warning">mdi-lock-open</v-icon>
                                          <span class="form-title">Unstake Tokens</span>
                                        </div>
                                        <div class="form-content">
                                          <v-text-field
                                            v-model="tokens_stake_out"
                                            class="wallet-input"
                                            :rules="tokensRulesStakeOut"
                                            label="Number of Tokens"
                                            required
                                            color="white"
                                            @focus="checkErrorsTokensStakeOut()"
                                            :error-messages="tokenValidationErrorsStakeOut"
                                          ></v-text-field>
                                          <v-btn
                                            @click="stakeTokensOut();"
                                            @keyup.enter.native="stakeTokensOut();"
                                            form="staking-form-out"
                                            :disabled="!validStakeOut"
                                            variant="outlined"
                                            color="warning"
                                            class="form-action-btn"
                                          >
                                            <v-icon left size="18">mdi-lock-open</v-icon>
                                            <span>Unstake Tokens</span>
                                          </v-btn>
                                        </div>
                                      </div>
                                    </v-form>

                                    <v-row v-if="this.stakeTokensErrorOut" justify="center" class="pa-0 pt-4 pb-0 ma-0">
                                      <v-col cols="12" align="center" class="pa-0 ma-0">
                                        <v-alert type="error" density="compact" class="error-alert">
                                          Something went wrong... Not enough tokens or other error occurred. Please try again later.
                                        </v-alert>
                                      </v-col>                         
                                    </v-row>

                                  </div>

                                  <v-divider class="section-divider"></v-divider>

                                  <!-- Wallet Actions Section -->
                                  <div class="wallet-section">
                                    <h2 class="section-title">
                                      <v-icon left>mdi-swap-horizontal</v-icon>
                                      Wallet Actions
                                    </h2>

                                    <!-- Available/In Transfer Cards -->
                                    <div class="balance-mini-cards">
                                      <div class="balance-mini-card">
                                        <div class="mini-card-label">
                                          <v-icon size="16">mdi-check-circle</v-icon>
                                          <span>Available</span>
                                        </div>
                                        <div class="mini-card-value">
                                          {{ formatNumber(this.cryptoUserData.tokens - this.cryptoUserData.tokens_vested - this.cryptoUserData.in_transfer) }} <span class="currency-small">MUZ</span>
                                        </div>
                                      </div>
                                      <div class="balance-mini-card">
                                        <div class="mini-card-label">
                                          <v-icon size="16">mdi-clock-outline</v-icon>
                                          <span>In Transfer</span>
                                        </div>
                                        <div class="mini-card-value">
                                          {{ formatNumber(this.cryptoUserData.in_transfer) }} <span class="currency-small">MUZ</span>
                                        </div>
                                      </div>
                                    </div>

                                    <!-- Transfer In Section -->
                                    <div class="transfer-section">
                                      <div class="transfer-header">
                                        <v-icon class="transfer-icon blink">mdi-arrow-right-bold</v-icon>
                                        <span class="transfer-title">Transfer In</span>
                                      </div>

                                      <div v-if="isMetamaskActive" class="transfer-content">
                                        <p class="transfer-description">Execute MUZ Token transfer from connected wallet</p>
                                        <v-btn
                                          @click="gotowallet();"
                                          variant="outlined"
                                          color="white"
                                          class="form-action-btn"
                                        >
                                          <v-icon left size="18">mdi-wallet</v-icon>
                                          <span>Go To Wallet</span>
                                        </v-btn>
                                        <v-alert v-if="errorMetamask != ''" type="error" density="compact" class="error-alert mt-3">
                                          {{ this.errorMetamask }}
                                        </v-alert>
                                      </div>

                                      <v-alert v-if="!isMetamaskActive" type="info" density="compact" class="info-alert">
                                        Wallet not active. Please activate it firstly using top right button.
                                      </v-alert>
                                    </div>

                                    <!-- Withdraw Section -->
                                    <div class="transfer-section">
                                      <div class="transfer-header">
                                        <v-icon class="transfer-icon blink">mdi-arrow-left-bold</v-icon>
                                        <span class="transfer-title">Withdraw</span>
                                      </div>

                                      <v-form ref="tokenformw" v-model="validW" id="check-token-formw" class="transfer-form">
                                        <div class="form-card">
                                          <div class="form-header">
                                            <v-icon>mdi-bank-transfer-out</v-icon>
                                            <span class="form-title">Transfer Tokens to Your Wallet</span>
                                          </div>
                                          <div v-if="this.connectedWallets.length > 0" class="form-content">
                                            <v-select
                                              v-model="address_to_send"
                                              class="wallet-input"
                                              label="Choose Address"
                                              required
                                              single-line
                                              color="white"
                                              item-value="address"      
                                              item-title="address"  
                                              :rules="[(v) => Boolean(Object.keys(v || {})[0]) || 'Address is required']"
                                              :items="connectedWallets"
                                              return-object
                                            >
                                              <template v-slot:selection="{ item }">
                                                <span class="select-text">{{ item['value'] }}</span>
                                              </template>
                                            </v-select>
                                            <v-text-field
                                              v-model="tokens_transfer_w"
                                              class="wallet-input"
                                              :rules="tokensRulesW"
                                              label="Number of Tokens"
                                              required
                                              color="white"
                                              @focus="checkErrorsTokensW()"
                                              :error-messages="tokenValidationErrorsW"
                                            ></v-text-field>
                                            <v-btn
                                              @click="sendTokensWallet();"
                                              form="check-token-formw"
                                              :disabled="!validW || true"
                                              variant="outlined"
                                              color="white"
                                              class="form-action-btn"
                                            >
                                              <v-icon left size="18">mdi-send</v-icon>
                                              <span>Send to Wallet</span>
                                            </v-btn>
                                            <v-alert type="info" density="compact" class="info-alert mt-3">
                                              Withdrawing to external Wallet will be available soon.
                                            </v-alert>
                                          </div>
                                          <v-alert v-else type="warning" density="compact" class="warning-alert">
                                            No Wallets Connected.
                                          </v-alert>
                                        </div>
                                      </v-form>

                                      <v-row v-if="this.sendTokenerrorW" justify="center" class="ma-0 pa-0 pt-2 pb-0">
                                        <v-col cols="12" align="center" class="pa-0 ma-0">
                                          <v-alert type="error" density="compact" class="error-alert">
                                            Something went wrong... Not enough tokens or other error occurred. Please try again later.
                                          </v-alert>
                                        </v-col>                         
                                      </v-row>
                                    </div>

                                    <!-- Transfer to User Section -->
                                    <v-form ref="tokenform" v-model="valid" id="check-token-form" class="transfer-form">
                                      <div class="form-card">
                                        <div class="form-header">
                                          <v-icon>mdi-account-arrow-right</v-icon>
                                          <span class="form-title">Transfer Tokens to Muzible User</span>
                                        </div>
                                        <div class="form-content">
                                          <v-text-field
                                            v-model="email"
                                            class="wallet-input"
                                            :rules="emailRules"
                                            label="Enter Email"
                                            required
                                            color="white"
                                            @focus="checkErrorsRegister()"
                                            :error-messages="emailValidationErrors"
                                          ></v-text-field>
                                          <v-text-field
                                            v-model="tokens_transfer"
                                            class="wallet-input"
                                            :rules="tokensRules"
                                            label="Number of Tokens"
                                            required
                                            color="white"
                                            @focus="checkErrorsTokens()"
                                            :error-messages="tokenValidationErrors"
                                          ></v-text-field>
                                          <v-btn
                                            @click="sendTokens();"
                                            form="check-token-form"
                                            :disabled="!valid || checking"
                                            variant="outlined"
                                            color="white"
                                            class="form-action-btn"
                                          >
                                            <v-icon left size="18">mdi-send</v-icon>
                                            <span>Send to User</span>
                                          </v-btn>
                                        </div>
                                      </div>
                                    </v-form>

                                    <v-row v-if="this.sendTokenerror" justify="center" class="ma-0 pa-0 pt-2">
                                      <v-col cols="12" align="center" class="pa-0 ma-0">
                                        <v-alert type="error" density="compact" class="error-alert">
                                          Something went wrong... Not enough tokens, user non-existing or some other error occurred. Please try again later.
                                        </v-alert>
                                      </v-col>  
                                    </v-row>

                                  </div>

                                  <v-divider class="section-divider"></v-divider>

                                  <!-- Connected Wallets Section -->
                                  <div class="wallet-section">
                                    <h2 class="section-title">
                                      <v-icon left>mdi-wallet-outline</v-icon>
                                      Connected Wallets
                                    </h2>

                                    <div v-if="this.connectedWallets.length > 0" class="wallets-list">
                                      <div v-for="(item, index) in connectedWallets" :key="index" class="wallet-item">
                                        <div class="wallet-address">
                                          <v-icon size="18" class="mr-2">mdi-wallet</v-icon>
                                          <span class="address-text">{{ item.address }}</span>
                                        </div>
                                        <v-btn
                                          @click="removeWallet(item.address)"
                                          variant="outlined"
                                          size="small"
                                          color="error"
                                          class="wallet-remove-btn"
                                        >
                                          <v-icon size="16">mdi-delete</v-icon>
                                          <span>Remove</span>
                                        </v-btn>
                                      </div>
                                    </div>

                                    <v-alert v-else type="info" density="compact" class="info-alert">
                                      No Wallets Connected.
                                    </v-alert>
                                  </div>

                                  <v-divider class="section-divider"></v-divider>

                                  <!-- Wallet History Section -->
                                  <div class="wallet-section">
                                    <h2 class="section-title">
                                      <v-icon left>mdi-history</v-icon>
                                      Wallet History
                                    </h2>

                                    <div v-if="this.accountHistory.length > 0" class="history-table">
                                      <div class="history-header">
                                        <div class="history-col history-col-action">Action</div>
                                        <div class="history-col history-col-from">To/From</div>
                                        <div class="history-col history-col-amount">Amount</div>
                                        <div class="history-col history-col-date">Date</div>
                                      </div>
                                      <div v-for="(item, index) in accountHistory" :key="index" class="history-row">
                                        <div class="history-col history-col-action">
                                          <v-chip size="x-small" variant="outlined">{{ item.type }}</v-chip>
                                        </div>
                                        <div class="history-col history-col-from">
                                          <span class="history-text">{{ item.from }}</span>
                                        </div>
                                        <div class="history-col history-col-amount">
                                          <span class="history-amount">{{ item.amount }}</span>
                                        </div>
                                        <div class="history-col history-col-date">
                                          <span class="history-text">{{ item.date }}</span>
                                        </div>
                                      </div>
                                      <v-alert type="info" density="compact" class="info-alert mt-4">
                                        Need full account history? Please contact us.
                                      </v-alert>
                                    </div>

                                    <v-alert v-else type="info" density="compact" class="info-alert">
                                      No transaction history available.
                                    </v-alert>
                                  </div>

                              </div>
                    </div>
                  </v-col>
                </v-row>                 
              </div>
            </div>
        </div>
        <v-row :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important':'padding-top:123px!important'"></v-row>
      </div>
    </div>
</div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Web3 from 'web3'
import LogoWhite from '../components/logo_white.vue';


export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Wallet',

  components: {
    LogoWhite
  },
  data: () => ({
    navbar: false,
    user: null,

    cryptoDashboardData: null,
    cryptoUserData: null,

    connectedWallets: [],
    accountHistory: [],
    sendTokenerror: false,
    sendTokenerrorW: false,
    stakeTokensError: false,
    stakeTokensErrorOut: false,
    emailValidationErrors: [],
    tokenValidationErrors: [],
    tokenValidationErrorsW: [],
    tokenValidationErrorsStakeIn: [],
    tokenValidationErrorsStakeOut: [],
    email: '',
    address_to_send: null,
    tokens_transfer: '',
    tokens_transfer_w: '',
    tokens_stake_in: '',
    tokens_stake_out: '',
    valid: false,
    validW: false,
    validStakeIn: false,
    validStakeOut: false,
    value: true,
    activatePassEnterBox: false,
    validpass: false,
    pass: '',
    checking: false,
    sendToWalletOption: false,
    passwordRules: [
        v => !!v || 'Password is required', 
        v => (v && v.length >= 5) || 'Password must have 5+ characters',
    ],
    passwordErrors: [],
    errorMetamask: '',
    errorMetamask2: '',
  }),
  mounted() {   
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    async email(val) {
          this.checking = true;
          this.emailValidationErrors = ['Checking..'];
          let resultcheck = /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(val)
          if (resultcheck){
            try {
              const res = await this.$store.dispatch('checkEmail', {email: val});
              if (val !== this.email) {
                this.checking = false;
                return false;
              }

              if (res.data === 0) { 
                this.emailValidationErrors = []; 
                this.checking = false;
                return true;
              } else { 
                this.emailValidationErrors = ['E-mail not found']; 
                this.checking = false;
                return false;
              } 
            } catch(error) {
              if (!error.response){
                this.emailValidationErrors = ['Service is down.. Try again later!'];
              } else if (error.response.status === 500) {
                this.emailValidationErrors = ['Service is down.. Try again later!'];
              } else {
                this.emailValidationErrors = [];
              }
              this.checking = false;
              return false;
            }
          } else {
            this.emailValidationErrors = ['Not valid email'];
            this.checking = false;
            return false;
          }
    },
    '$store.state.user': function() {
          this.user = this.$store.getters.getUserData;
    },    
  },
  computed: {
    getStaked() {
        if (this.cryptoUserData) {
          if (this.cryptoUserData.tokens > 0) {
            return `${this.cryptoUserData.tokens_vested} MUZ | ${((this.cryptoUserData.tokens_vested * 100) / this.cryptoUserData.tokens).toFixed(2)} %`;
          } else {
            return `${this.cryptoUserData.tokens_vested} MUZ | 0 %`;
          }
        }
        return '0 MUZ | 0 %';
    },
    isfullScreen(){
      if(this.isMobile && this.isMobileXs){
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
          return this.$store.getters.getUserData != null
      },
    isDesktop() {
        if (!this.navbar){
          return true;
        } else {
          return false;
        }
      },
    getGextPanel() {
      if(this.navbar){
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
    isMetamaskActive() {
            return this.$store.getters.getIsMetamaskWalletActive;
    },
    tokensRules() { return [
              v => {
                    this.tokenValidationErrors=[];
                    var val= !!v
                    if(val){
                      return true
                    } else {
                      return 'Enter amount'
                  }},
              v => (/(\d*\.\d+),?/.test(v) || /(\d*\.\d+|\d+),?/.test(v)) || 'Only Numbers',
              v => /^[+-]?\d+(\.\d+)?$/.test(v) || 'Not Valid',
              v => parseFloat(v) > parseFloat(0) || 'Must be greater than zero',
              v => {
                const decimalPart = v.toString().split('.')[1];
                return !decimalPart || decimalPart.length <= 6 || 'Maximum 6 decimal places';
              },
              v => parseFloat(v) <= parseFloat(parseFloat(this.cryptoUserData.tokens) - parseFloat(this.cryptoUserData.tokens_vested) - parseFloat(this.cryptoUserData.in_transfer)) || 'Not enough Tokens'
              ]
    },
    tokensRulesStakeIn() { return [
              v => {
                    this.tokenValidationErrorsStakeIn=[];
                    var val= !!v
                    if(val){
                      return true
                    } else {
                      return 'Enter amount'
                  }},
              v => (/(\d*\.\d+),?/.test(v) || /(\d*\.\d+|\d+),?/.test(v)) || 'Only Numbers',
              v => /^[+-]?\d+(\.\d+)?$/.test(v) || 'Not Valid',
              v => parseFloat(v) > parseFloat(0) || 'Must be greater than zero',
              v => {
                const decimalPart = v.toString().split('.')[1];
                return !decimalPart || decimalPart.length <= 6 || 'Maximum 6 decimal places';
              },
              v => parseFloat(v) <= parseFloat(parseFloat(this.cryptoUserData.tokens) - parseFloat(this.cryptoUserData.tokens_vested) - parseFloat(this.cryptoUserData.in_transfer)) || 'Not enough Tokens'
              ]
    },
    tokensRulesStakeOut() { return [
              v => {
                    this.tokenValidationErrorsStakeOut=[];
                    var val= !!v
                    if(val){
                      return true
                    } else {
                      return 'Enter amount'
                  }},
              v => (/(\d*\.\d+),?/.test(v) || /(\d*\.\d+|\d+),?/.test(v)) || 'Only Numbers',
              v => /^[+-]?\d+(\.\d+)?$/.test(v) || 'Not Valid',
              v => parseFloat(v) > parseFloat(0) || 'Must be greater than zero',
              v => {
                const decimalPart = v.toString().split('.')[1];
                return !decimalPart || decimalPart.length <= 6 || 'Maximum 6 decimal places';
              },
              v => parseFloat(v) <= parseFloat(this.cryptoUserData.tokens_vested) || 'Not enough Tokens'
              ]
      },
      tokensRulesW() { return [
              v => {
                    this.tokenValidationErrorsW=[];
                    var val= !!v
                    if(val){
                      return true
                    } else {
                      return 'Enter amount'
                  }},
              v => (/(\d*\.\d+),?/.test(v) || /(\d*\.\d+|\d+),?/.test(v)) || 'Only Numbers',
              v => /^[+-]?\d+(\.\d+)?$/.test(v) || 'Not Valid',
              v => parseFloat(v) > parseFloat(0) || 'Must be greater than zero',
              v => parseFloat(v) >= parseFloat(50) || 'Minimum 50 Tokens',
              v => {
                const decimalPart = v.toString().split('.')[1];
                return !decimalPart || decimalPart.length <= 6 || 'Maximum 6 decimal places';
              },
              v => parseFloat(v) <= parseFloat(parseFloat(this.cryptoUserData.tokens) - parseFloat(this.cryptoUserData.tokens_vested) - parseFloat(this.cryptoUserData.in_transfer)) || 'Not enough Tokens'
              ]
      },
      emailRules() { return [
                v => {
                  var val= !!v
                  if(val){
                    return true
                  } else {
                    this.emailValidationErrors=[];
                    return 'E-mail is required'
                  }},
                v => {
                if (/.+@.+/.test(v)) {
                  return true;
                } else {
                  this.emailValidationErrors = [];
                  return 'E-mail must be valid';
                }
                },
                v => {
                if (/(^.+@(\[?)[a-zA-Z0-9-.]+.([a-zA-Z]{2,3}|[0-9]{1,3})(]?)$)/.test(v)) {
                  return true;
                } else {
                  this.emailValidationErrors = [];
                  return 'E-mail must be valid';
                }
                },
                v => {
                const isValid = /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(v);
                if (!isValid) {
                  this.emailValidationErrors = [];
                }
                return isValid || 'E-mail must be valid';
                },
                v => {
                const isValid = v.trim() !== this.user.email;
                if (!isValid) {
                  this.emailValidationErrors = [];
                }
                return isValid || 'You cannot send to yourself';
                },
              ]
      },
  },  
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;    

      if(window.innerWidth > 768){
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.$store.dispatch('getCryptoDashboardData').then( response => {        
      this.cryptoDashboardData = this.$store.getters.getCryptoDashboardData
      }).catch( error => {
        if (!error.response) {
          this.notifyError("Error occured.. Please try again later.");
        }
      })

      if (this.isLogged){
        this.$store.dispatch('getCryptoUserData', { token: this.user.token}).then( response => {
          this.cryptoUserData = this.$store.getters.getCryptoUserData          
        }).catch( error => {
          if (!error.response) {
            this.notifyError("Error occured.. Please try again later.");
          }
        })
      }

      if (this.isLogged){
        this.$store.dispatch('getUserMetamaskWallets', { uid: this.user.uid, token: this.user.token}).then( response => {
          this.connectedWallets = this.$store.getters.getUserMetamaskWallets       
        }).catch( error => {
          if (!error.response) {
            this.notifyError("Error occured.. Please try again later.");
          }
        })
      }

      if (this.isLogged){
          this.$store.dispatch('getAccountHistoryWallets', { uid: this.user.uid, token: this.user.token}).then( response => {
            this.accountHistory = this.$store.getters.getAccountHistoryWallets       
          }).catch( error => {
            if (!error.response) {
              this.notifyError("Error occured.. Please try again later.");
            }
          })
      }

      this.emitter.on('activatePassEnter', () => {
        this.activatePassEnterBox = true;
        this.passwordErrors = [];
      })

    }
  }, 
  methods: {
    sleeper2() {
        return new Promise(resolve => setTimeout(resolve, 2000));
    },
    formatNumber(number) {
        let integer = parseInt(number);

        if (number == integer)
            return number;
        else {
            return parseFloat(number).toFixed(6).replace(/\.?0+$/, '');
        }
    },
      gotowallet() {
        this.errorMetamask = '';
        this.errorMetamask2 = '';
        if (this.$store.getters.getMetamaskWallet && this.$store.getters.getMetamaskWallet.web3){
          const tokenInst = new this.$store.getters.getMetamaskWallet.web3.eth.Contract(this.$store.getters.getLifeTokenABI, this.$store.getters.getLifeTokenAddress);
          var resultSend = tokenInst.methods.transfer(this.$store.getters.getLifeMasterAddress,parseInt(parseFloat(this.$store.getters.getMetamaskBalance) * (10 ** this.$store.getters.getDecimals)));
          this.emitter.emit('transactionInProgress');
          resultSend.send({from: this.$store.getters.getMetamaskWallet.metaMaskAddress})
          .on('confirmation', (confirmationNumber, receipt) => {
            if (confirmationNumber === 2){
              var data2 = {
                  transactionHash: receipt.transactionHash,
              }
              this.emitter.emit('transactionData', data2);
              this.emitter.emit('refreshMetamaskBalance');
              this.sleeper2().then( rxs => {
              this.$store.dispatch('executeMetamaskTokenTransferIntent', { token: this.user.token, trx: receipt.transactionHash, from: this.$store.getters.getMetamaskWallet.metaMaskAddress, to: this.$store.getters.getLifeMasterAddress })
                  .then( response => {
                      this.refreshWallet();                    
                      this.emitter.emit('transactionInProgressEnd');                          
                  })
                  .catch( error => {
                    this.errorMetamask = 'Error occured during transaction processing. Please contact support.';

                    this.emitter.emit('transactionInProgressEndError', this.errorMetamask)
                    this.emitter.emit('transactionInProgressEnd');
                  })
              })
            }
          })
          .on('error', (error) => {
            this.errorMetamask = error.message;
            this.emitter.emit('transactionInProgressEndError', this.errorMetamask)
            this.emitter.emit('transactionInProgressEnd');
          })
        }
      },
      sendTokens() {
            this.sendToWalletOption = false;
            this.pass = '';
            this.validpass = false;
            this.passwordErrors = [];
            this.value = true;
            this.sendTokenerror = false;
            this.emitter.emit('activatePassEnter');
      },
      sendTokensWallet() {
            this.sendTokenerrorW = false;
            this.sendToWalletOption = true;
            this.pass = '';
            this.validpass = false;
            this.passwordErrors = [];
            this.value = true;
            this.emitter.emit('activatePassEnter');
      },
      stakeTokensIn() {
            this.stakeTokensError = false;
            this.$store.dispatch('moveToStaking', { token: this.$store.getters.getUserData.token, 
                                                    amount: this.tokens_stake_in } )
                .then( response => {
                    this.tokens_stake_in = '';
                    this.tokenValidationErrorsStakeIn = [];
                    this.$refs.stakingformin.reset();

                    if (response.data.ok){
                      this.refreshWallet();
                    } else {
                      this.notifyError("Error occured.. Please try again later.");
                      this.stakeTokensError = true;
                    }
                })
                .catch( error => {
                    if (!error.response){
                        this.stakeTokensError = true;      
                    } else {
                        this.stakeTokensError = true;  
                    }
                });
      },
      stakeTokensOut(){
            this.stakeTokensErrorOut = false;
            this.$store.dispatch('moveFromStaking', { token: this.$store.getters.getUserData.token, 
                                                      amount: this.tokens_stake_out } )
                .then( response => {
                    this.tokens_stake_out = '';
                    this.tokenValidationErrorsStakeOut = [];
                    this.$refs.stakingformout.reset();

                    if (response.data.ok){
                      this.refreshWallet();
                    } else {
                      this.notifyError("Error occured.. Please try again later.");
                      this.stakeTokensErrorOut = true;
                    }
                })
                .catch( error => {
                    if (!error.response){
                        this.stakeTokensErrorOut = true;      
                    } else {
                        this.stakeTokensErrorOut = true;  
                    }
                });
      },
      sendTokensPassWallet() {
            this.$store.dispatch('sendTokensToWallet', { pass: this.pass, 
                                                         token: this.$store.getters.getUserData.token, 
                                                         amount: this.tokens_transfer_w,
                                                         address: this.address_to_send.address} )
                .then( response => {
                    this.activatePassEnterBox = false;
                    this.pass = '';
                    this.tokens_transfer_w = '';
                    this.tokenValidationErrorsW = [];
                    this.$refs.tokenformw.reset();
                    this.$refs.formpasswallet.reset();
                    

                    if (response.data.ok){
                      this.refreshWallet();
                    } else {
                      this.notifyError("Error occured.. Please try again later.");
                      this.sendTokenerrorW = true;
                    }
                })
                .catch( error => {
                    this.$refs.formpasswallet.reset();
                    
                    if (!error.response){
                        this.passwordErrors = ['Service is down.. Try again later!'];    
                    } else {
                        this.passwordErrors = ['Bad Password..'];
                    }
                });
      },
      sendTokensPass() {
            this.$store.dispatch('sendTokensToUser', { pass: this.pass, 
                                                       token: this.$store.getters.getUserData.token, 
                                                       amount: this.tokens_transfer,
                                                       touser: this.email} )
                .then( response => {
                    this.activatePassEnterBox = false;
                    this.pass = '';
                    this.tokens_transfer = '';
                    this.emailValidationErrors = [];
                    this.tokenValidationErrors = [];
                    this.$refs.tokenform.reset();
                    this.email = '';
                    this.$refs.formpasswallet.reset();
                    

                    if (response.data.ok){
                      this.refreshWallet();
                    } else {
                      this.notifyError("Error occured.. Please try again later.");
                      this.sendTokenerror = true;
                    }
                })
                .catch( error => {
                    this.$refs.formpasswallet.reset();
                    
                    if (!error.response){
                        this.passwordErrors = ['Service is down.. Try again later!'];    
                    } else {
                        this.passwordErrors = ['Bad Password..'];    
                    }
                });
      },
      checkErrorsPass() {
          if ((this.passwordErrors['Service is down.. Try again later!'] !== 'undefined' ||
              this.passwordErrors['Bad Password..'] !== 'undefined')){
              this.passwordErrors = [];
          }
      },
      checkErrorsTokens() {
        if (this.tokenValidationErrors.length != 0
            && (this.tokenValidationErrors[0] === 'Service is down.. Try again later!')){
            this.tokenValidationErrors = [];
        }
      },
      checkErrorsTokensW() {
        if (this.tokenValidationErrorsW.length != 0
            && (this.tokenValidationErrorsW[0] === 'Service is down.. Try again later!')){
            this.tokenValidationErrorsW = [];
        }
      },
      checkErrorsTokensStakeIn() {
        if (this.tokenValidationErrorsStakeIn.length != 0
            && (this.tokenValidationErrorsStakeIn[0] === 'Service is down.. Try again later!')){
            this.tokenValidationErrorsStakeIn = [];
        }
      },
      checkErrorsTokensStakeOut() {
        if (this.tokenValidationErrorsStakeOut.length != 0
            && (this.tokenValidationErrorsStakeOut[0] === 'Service is down.. Try again later!')){
            this.tokenValidationErrorsStakeOut = [];
        }
      },
      checkErrorsRegister() {
        if (this.emailValidationErrors.length != 0
            && (this.emailValidationErrors[0] === 'Service is down.. Try again later!')){
            this.emailValidationErrors = [];
        }
      },
      getCountedDaysYield(eq){
          const _MS_PER_DAY = 1000 * 60 * 60 * 24;
          const date1 = new Date(eq.yield_date);
          const date2 = new Date();

          const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
          const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

          let returned_date = '';
          returned_date = Math.floor((utc2 - utc1) / _MS_PER_DAY) + ' days';

          return returned_date;
      },
      gotolink(link) {
          window.open(link,'_blank');
      },
      removeWallet(address_toremove){
        this.$store.dispatch('removeMetamaskWallet', { uid: this.user.uid, token: this.user.token, address: address_toremove}).then( response => {
          if (response.data.removed){
                  this.$store.dispatch('getUserMetamaskWallets', { uid: this.user.uid, token: this.user.token}).then( response => {
                    this.connectedWallets = this.$store.getters.getUserMetamaskWallets        
                  }).catch( error => {
                    if (!error.response) {
                      this.notifyError("Error occured.. Please try again later.");
                    }
                  })
          } else {
            this.notifyError("Error occured.. Please try again later.");
          }     
        }).catch( error => {
          if (!error.response) {
            this.notifyError("Error occured.. Please try again later.");
          }
        })
      },
      returnPlusNeutralMinus(eq){
        if (this.positiveReturn(eq)){
          return "+ " + this.positiveReturnCurAmount(eq)
        } else if (this.neutralReturn(eq)){
          return 0;
        } else if (this.negativeReturn(eq)){
          return "- " + this.negativeReturnCurAmount(eq)
        }
      },
      positiveReturn(eq){
        if (parseFloat(parseFloat(eq.current_price).toFixed(1)) > parseFloat(parseFloat(eq.listing_price).toFixed(1))){
          return true;
        } else {
          return false;
        }
      },
      positiveReturnCurAmount(eq){
        return parseFloat(parseFloat(((parseFloat(eq.current_price).toFixed(2) - parseFloat(eq.listing_price).toFixed(2))/parseFloat(eq.listing_price).toFixed(2))*100).toFixed(1));
      },
      neutralReturn(eq){
        if (parseFloat(parseFloat(eq.current_price).toFixed(1)) === parseFloat(parseFloat(eq.listing_price).toFixed(1))){
          return true;
        } else {
          return false;
        }
      },
      negativeReturnCurAmount(eq){
        return parseFloat(parseFloat(((parseFloat(eq.listing_price).toFixed(2) - parseFloat(eq.current_price).toFixed(2))/parseFloat(eq.listing_price).toFixed(2))*100).toFixed(1));
      },
      negativeReturn(eq){
        if (parseFloat(parseFloat(eq.current_price).toFixed(1)) < parseFloat(parseFloat(eq.listing_price).toFixed(1))){
          return true;
        } else {
          return false;
        }
      },
      refreshWallet() {
              this.$store.dispatch('getCryptoDashboardData').then( response => {        
                this.cryptoDashboardData = this.$store.getters.getCryptoDashboardData
                }).catch( error => {
                  if (!error.response) {
                    this.notifyError("Error occured.. Please try again later.");
                  }
                })

              if (this.isLogged){
                  this.$store.dispatch('getCryptoUserData', { token: this.user.token}).then( response => {
                    this.cryptoUserData = this.$store.getters.getCryptoUserData          
                  }).catch( error => {
                    if (!error.response) {
                      this.notifyError("Error occured.. Please try again later.");
                    }
                  })
              }
              if (this.isLogged){
                  this.$store.dispatch('getUserMetamaskWallets', { uid: this.user.uid, token: this.user.token}).then( response => {
                    this.connectedWallets = this.$store.getters.getUserMetamaskWallets        
                  }).catch( error => {
                    if (!error.response) {
                      this.notifyError("Error occured.. Please try again later.");
                    }
                  })
              }

              if (this.isLogged){
                  this.$store.dispatch('getAccountHistoryWallets', { uid: this.user.uid, token: this.user.token}).then( response => {
                    this.accountHistory = this.$store.getters.getAccountHistoryWallets        
                  }).catch( error => {
                    if (!error.response) {
                      this.notifyError("Error occured.. Please try again later.");
                    }
                  })
              }
      },
      checkScreenSize() {
        if(window.innerWidth > 768){
          this.navbar = false;
        } else {
          this.navbar = true;
        }
      },
      handleClickMenu(link){
        if (link === 'Terms'){
          window.open('https://muzible.com/terms','_blank');
        } else if (link === 'Privacy'){
          window.open('https://muzible.com/privacy','_blank');
        } else if (link === 'TryMuzE'){
          window.location.href = 'https://muze.muzible.com/';
        } else if (link === 'TryVerse'){
          window.location.href = 'https://verse.muzible.com/';
        } else {
          if (this.$route.name !== link ) {
            this.$router.push({ name: link });
          }
        }
      }
  }
}
</script>

<style lang="scss" scoped>


@use './css/styles.scss';

/* Wallet Header */
.wallet-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

/* Balance Cards Grid */
.balance-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

@media (max-width: 768px) {
  .balance-cards-grid {
    grid-template-columns: 1fr;
  }
}

/* Balance Card */
.balance-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.balance-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.balance-card:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.balance-card:hover::before {
  opacity: 1;
}

.balance-card-primary {
  border-color: rgba(76, 175, 80, 0.3);
}

.balance-card-primary:hover {
  border-color: rgba(76, 175, 80, 0.6);
  box-shadow: 0 8px 32px rgba(76, 175, 80, 0.2);
}

.balance-card-primary::before {
  background: linear-gradient(90deg, transparent, rgba(76, 175, 80, 0.6), transparent);
}

.balance-card-staked {
  border-color: rgba(255, 152, 0, 0.3);
}

.balance-card-staked:hover {
  border-color: rgba(255, 152, 0, 0.6);
  box-shadow: 0 8px 32px rgba(255, 152, 0, 0.2);
}

.balance-card-staked::before {
  background: linear-gradient(90deg, transparent, rgba(255, 152, 0, 0.6), transparent);
}

.balance-card-dividend {
  border-color: rgba(33, 150, 243, 0.3);
}

.balance-card-dividend:hover {
  border-color: rgba(33, 150, 243, 0.6);
  box-shadow: 0 8px 32px rgba(33, 150, 243, 0.2);
}

.balance-card-dividend::before {
  background: linear-gradient(90deg, transparent, rgba(33, 150, 243, 0.6), transparent);
}

.balance-card-potential {
  border-color: rgba(156, 39, 176, 0.3);
}

.balance-card-potential:hover {
  border-color: rgba(156, 39, 176, 0.6);
  box-shadow: 0 8px 32px rgba(156, 39, 176, 0.2);
}

.balance-card-potential::before {
  background: linear-gradient(90deg, transparent, rgba(156, 39, 176, 0.6), transparent);
}

.balance-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.balance-icon {
  opacity: 0.8;
}

.balance-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.balance-value {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.balance-value-small {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}

.currency {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.currency-small {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.percentage {
  display: block;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

/* Section Divider */
.section-divider {
  margin: 40px 0 !important;
  opacity: 0.2;
}

/* Wallet Section */
.wallet-section {
  margin-bottom: 40px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Staking Form */
.staking-form {
  margin-bottom: 24px;
}

/* Form Card */
.form-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s ease;
}

.form-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.form-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.form-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: white;
}

.form-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Wallet Input */
.wallet-input {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 8px !important;
}

:deep(.wallet-input .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

:deep(.wallet-input .v-field:hover) {
  border-color: rgba(255, 255, 255, 0.3) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

:deep(.wallet-input .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.5) !important;
  background: rgba(255, 255, 255, 0.1) !important;
}

:deep(.wallet-input .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.wallet-input .v-field__input) {
  color: white !important;
  font-weight: 500;
}

/* Form Action Button */
.form-action-btn {
  width: 100%;
  height: 48px !important;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  transition: all 0.3s ease;
}

.form-action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.form-action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none !important;
}

/* Balance Mini Cards */
.balance-mini-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.balance-mini-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 16px;
  transition: all 0.3s ease;
}

.balance-mini-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.mini-card-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mini-card-value {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

/* Transfer Section */
.transfer-section {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.transfer-section:hover {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
}

.transfer-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.transfer-icon {
  font-size: 24px !important;
}

.transfer-icon.blink {
  animation: blink 2s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.transfer-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: white;
}

.transfer-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.transfer-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.6;
}

.transfer-form {
  margin-top: 16px;
}

/* Wallets List */
.wallets-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wallet-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.wallet-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateX(4px);
}

.wallet-address {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.address-text {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.wallet-remove-btn {
  flex-shrink: 0;
  height: 32px !important;
  font-size: 13px !important;
  text-transform: none !important;
  border-radius: 6px !important;
}

.wallet-remove-btn:hover {
  background: rgba(244, 67, 54, 0.1) !important;
}

/* History Table */
.history-table {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
}

.history-header {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1.5fr;
  gap: 16px;
  background: rgba(255, 255, 255, 0.08);
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.history-row {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1.5fr;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.history-row:last-child {
  border-bottom: none;
}

.history-row:hover {
  background: rgba(255, 255, 255, 0.05);
}

.history-col {
  display: flex;
  align-items: center;
}

.history-col-action {
  font-size: 13px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.history-col-from,
.history-col-amount,
.history-col-date {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
}

.history-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.history-amount {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
}

@media (max-width: 768px) {
  .history-header,
  .history-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .history-col {
    padding: 4px 0;
  }
}

/* Alerts */
.error-alert {
  background: rgba(244, 67, 54, 0.1) !important;
  border: 1px solid rgba(244, 67, 54, 0.3) !important;
  border-radius: 8px !important;
}

.info-alert {
  background: rgba(33, 150, 243, 0.1) !important;
  border: 1px solid rgba(33, 150, 243, 0.3) !important;
  border-radius: 8px !important;
}

.warning-alert {
  background: rgba(255, 152, 0, 0.1) !important;
  border: 1px solid rgba(255, 152, 0, 0.3) !important;
  border-radius: 8px !important;
}

:deep(.v-alert__content) {
  color: white !important;
  font-size: 13px;
  font-weight: 500;
}

/* Select Text */
.select-text {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: white;
  font-weight: 500;
}

:deep(.v-select .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px !important;
}

:deep(.v-select .v-field:hover) {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* Password Dialog */
.password-dialog {
  background: #121212 !important;
  color: white !important;
  border-radius: 16px !important;
}

.dialog-info-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

.dialog-password-field {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 8px !important;
  min-width: 300px;
}

:deep(.dialog-password-field .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px !important;
}

:deep(.dialog-password-field .v-field:hover) {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

:deep(.dialog-password-field .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.dialog-action-btn {
  width: 200px;
  height: 44px !important;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.dialog-action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.balance-card {
  animation: slideIn 0.4s ease forwards;
}

.balance-card:nth-child(1) { animation-delay: 0.05s; }
.balance-card:nth-child(2) { animation-delay: 0.1s; }
.balance-card:nth-child(3) { animation-delay: 0.15s; }
.balance-card:nth-child(4) { animation-delay: 0.2s; }

/* Override Vuetify styles */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-chip) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}


.info-section {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border-left: 3px solid rgba(255, 255, 255, 0.3);
}

.info-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

.metamask-content {
  padding: 32px 24px 24px 24px !important;
  color: white;
}

@media (max-width: 600px) {
  .metamask-content {
    padding: 24px 16px !important;
  }

  .metamask-actions {
    flex-direction: column;
    gap: 12px;
  }

  .cancel-btn,
  .activate-btn {
    width: 100%;
  }
}

/* Actions */
.metamask-actions {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.3);
}

.metamask-header {
  background: rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
